import history from '../history/history';
import projectService from '../services/project/ProjectService';
import {captureError} from './log';

export function goToProject(projectId, interventionId) {
  projectService.isProjectReady(interventionId)
    .then(() => history.push(`/project/${projectId}/intervention/${interventionId}`))
    .catch(error => {
      captureError('Error while checking if project is ready to be consulted', error);
    });
}
